<template>
  <div class="full-height">
    <div class="fit container-crud q-px-sm">
      <div class="fit">
        <q-card class="fit q-px-sm">
          <q-scroll-area class="container-page-person shadow-1">
            <q-card-section class="q-py-sm">
              <div v-if="nmInterface === 'gravar'" class="crud-title">
                <translate>NEW_REGISTRATION</translate>
              </div>
              <div v-else-if="nmInterface === 'alterar'" class="crud-title">
                <translate>UPDATE</translate>
              </div>
              <div v-else-if="nmInterface === 'detalhar'" class="crud-title">
                <translate>VIEW_REGISTRATION</translate>
              </div>
            </q-card-section>
            <q-card-section class="q-px-lg container-person row">
              <span v-if="elements.length == 1" class="col-8">
                <div name="form-wrapper" >
                  <jt-dynamic-form
                    ref="dynamicForm"
                    :inputs="inputs"
                    :relacionamentos="elements[0].relacionamentos"
                    :model="elements[0].dadosForm"
                    :interface="elements[0].nmInterface"
                    form-class="form dynamic margin-bottom"
                  />
                    <translate>ASSIGNMENTS</translate>
                      <q-separator />
                      <div class="assignments">
                        <q-btn v-show="hasProperty('carrier')" class="btn-carrier btn-atribuation" @click="() => {openModal('carrier.pesquisarCustomizado', this.$gettext('TRANSPORTER'))}" >
                          <translate class="in">TRANSPORTER</translate>
                          <q-icon name="open_in_new" color="white"/>
                        </q-btn>
                        <q-btn v-show="hasProperty('generator')" class="btn-generator btn-atribuation" @click="() => {openModal('generator.pesquisarCustomizado', this.$gettext('GENERATOR'))}">
                          <translate class="in">GENERATOR</translate>
                          <q-icon name="open_in_new" color="white"/>
                        </q-btn>
                        <q-btn v-show="hasProperty('client')" class="btn-client btn-atribuation" @click="() => {openModal('client.pesquisar', this.$gettext('CUSTOMER'))}">
                          <translate class="in">CUSTOMER</translate>
                          <q-icon name="open_in_new" color="white"/>
                        </q-btn>
                        <q-btn v-show="hasProperty('userWaste')" class="btn-user btn-atribuation" >
                          <translate class="in">USER</translate>
                        </q-btn>
                        <q-btn v-show="hasProperty('serviceSupplier')" class="btn-serviceProvider btn-atribuation" >
                          <translate class="in">SERVICE_PROVIDER</translate>
                        </q-btn>
                      </div>
                  </div>
                </span>
              <div class="col-4">
                <div class="justify-center">
                  <div class="text-center text-primary text-sub">
                    {{ avatarImageLabel }}
                  </div>
                </div>
                <q-card-section
                  class="row full-width q-col-gutter-y-md justify-center q-pt-md"
                >
                  <q-avatar size="8em">
                    <img id="avatar" :src="urlAvatar" />
                  </q-avatar>
                  <div class="col-12 text-primary text-center">
                    <q-btn
                      flat
                      class="cursor-pointer text-sub"
                      @click="resetAvatarImage"
                      :disable="interfaceDetails"
                    >
                      <translate>REMOVE_PERSON_IMAGE</translate>
                    </q-btn>
                  </div>
                  <jt-file-picker
                    filled
                    required
                    name="form-wrapper"
                    v-model="avatarFile"
                    @input="avatarFileChange"
                    :disable="interfaceDetails"
                    :label="$gettext('UPLOAD_PERSON_IMAGE')"
                  >
                    <template v-slot:prepend>
                      <q-icon name="folder_open" @click.stop />
                    </template>
                    <template v-slot:append>
                      <q-btn
                        round
                        dense
                        flat
                        icon="cancel"
                        @click.stop="avatarFile = null"
                        class="cursor-pointer"
                      />
                    </template>
                  </jt-file-picker>
                </q-card-section>

                <div class="justify-center">
                  <div class="text-center text-primary text-sub">
                    {{ signatureImageLabel }}
                  </div>
                </div>
                <q-card-section
                  class="row full-width q-col-gutter-y-md justify-center q-pt-md"
                >
                  <q-avatar size="8em">
                    <img id="avatar" :src="urlSignature" />
                  </q-avatar>
                  <div class="col-12 text-primary text-center">
                    <q-btn
                      flat
                      class="cursor-pointer text-sub"
                      @click="resetSignatureImage"
                      :disable="interfaceDetails"
                    >
                      <translate>REMOVE_PERSON_IMAGE</translate>
                    </q-btn>
                  </div>
                  <jt-file-picker
                    filled
                    required
                    name="form-wrapper"
                    v-model="signatureFile"
                    @input="signatureFileChange"
                    :disable="interfaceDetails"
                    :label="$gettext('UPLOAD_PERSON_IMAGE')"
                  >
                    <template v-slot:prepend>
                      <q-icon name="folder_open" @click.stop />
                    </template>
                    <template v-slot:append>
                      <q-btn
                        round
                        dense
                        flat
                        icon="cancel"
                        @click.stop="signatureFile = null"
                        class="cursor-pointer"
                      />
                    </template>
                  </jt-file-picker>
                </q-card-section>
              </div>
            </q-card-section>
            <q-card-section class="margin-top-minus">
              <q-tabs
                id="jt-compositions"
                v-model="tab"
                align="start"
                color="dark"
                dense
                active-color="primary"
                indicator-color="primary"
              >
                <q-tab
                  v-for="(tab, index) in computedCompositionsTypeElements"
                  :key="index"
                  :name="'xtab-' + index"
                  :label="tab.title || tab.label"
                  :icon="tab.icon"
                  :default="index === 0"
                />
              </q-tabs>
              <q-separator />
              <q-tab-panels v-model="tab" animated>
                <q-tab-panel :key="index" :name="'xtab-0'" keep-alive>
                  <jt-composition
                    ref="compositions"
                    class="dynamic-compositions"
                    :columns="compositions[0].columns"
                    :data="compositions[0].data"
                    :buttons="compositions[0].buttons"
                    :allow-custom-edit-modal="
                      compositions[0].model == 'addressPersons'
                    "
                    @on-add="newAddressPerson"
                    @on-edit="editAddressPerson"
                    @on-remove="onRemoveAddressHandler"
                    v-key="compositions[0].model"
                  />
                </q-tab-panel>

                <q-tab-panel :key="index" :name="'xtab-1'" keep-alive>
                  <jt-composition
                    ref="compositions"
                    class="dynamic-compositions"
                    :columns="compositions[1].columns"
                    :data="compositions[1].data"
                    :buttons="compositions[1].buttons"
                    @on-remove="onRemoveDocumentHandler"
                    v-key="compositions[1].model"
                  />
                </q-tab-panel>
                <q-tab-panel :key="index" :name="'xtab-2'" keep-alive>
                  <jt-composition
                    ref="compositions"
                    class="dynamic-compositions"
                    :columns="compositions[2].columns"
                    :data="compositions[2].data"
                    :buttons="compositions[2].buttons"
                    :allow-custom-edit-modal="
                      compositions[2].model == 'contactPersons'
                    "
                    @on-add="newContactPerson"
                    @on-edit="editContactPerson"
                    @on-remove="onRemoveContactPersonHandler"
                    v-key="compositions[2].model"
                  />
                </q-tab-panel>
              </q-tab-panels>
            </q-card-section>
          </q-scroll-area>
        </q-card>
      </div>
    </div>
    <div
      class="row full-width q-col-gutter-lg justify-center q-py-lg"
      v-if="forms[0] && forms[0].buttons.length > 0"
    >
      <div class="col-lg-2 col-md-3">
        <q-btn class="full-width" color="grey-7" @click="limparForm">
          <translate>CLEAN</translate>
        </q-btn>
      </div>
      <div
        v-for="(button, i) in forms[0].buttons"
        :key="i"
        class="col-lg-2 col-md-3"
      >
        <q-btn class="full-width" color="info" @click="actionButton(button)">
          <q-icon
            v-if="button.icon"
            :name="button.icon"
            size="18px"
            class="position-icon-filter"
          />
          {{ button.label }}
        </q-btn>
      </div>
    </div>
    <address-person
      v-if="addressPersonShow"
      ref="addressPersonModal"
      :form="addressPersonForm"
      :composicaos="addressPersonData"
      :nr-linha-selecionada="addressPersonForm.nrLinhaSelecionada"
      :fl-composicao-alteracao="editMode"
      @onAddSuccess="onAddAddressSuccessHandler"
      @onEditSuccess="onEditAddressSuccessHandler"
    />

    <contact-person
      v-if="contactPersonShow"
      ref="contactPersonModal"
      :form="contactPersonForm"
      :composicaos="contactPersonData"
      :nr-linha-selecionada="contactPersonForm.nrLinhaSelecionada"
      :fl-composicao-alteracao="editMode"
      @onAddSuccess="onAddContactSuccessHandler"
      @onEditSuccess="onEditContactSuccessHandler"
    />
    <person-component-modal
      v-if = "dadosModal.show"
      :show = "dadosModal.show"
      :interface="dadosModal.interface"
      :label="dadosModal.label"
      :person="dadosModal.person"
      @on-close="teste"
    />
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import {
  JtCrud,
  JtDynamicForm,
  JtFilePicker,
  JtComposition,
  JtCompositions
} from 'jtech-webcomps'
import { QAvatar, QTab, QTabPanel, QTabPanels } from 'quasar'
import { repository, messageBox } from 'jtech'
import ContactPerson from './ContactPerson'
import AddressPerson from './AddressPerson'
import PersonComponentModal from './PersonComponentModal'

import * as defaultAvatarImage from '../../../assets/avatar.jpg'
import * as defaultSignatureImage from '../../../assets/signature.png'
const { page, pageTable, modal } = JtCrud
import _ from 'lodash'

@Component({
  mixins: [page],
  inject: ['jtdynamicform'],
  name: 'PersonPage',
  components: {
    JtDynamicForm,

    JtFilePicker,
    JtComposition,
    JtCompositions,
    QTab,
    QTabPanel,
    QTabPanels,
    ContactPerson,
    AddressPerson,
    PersonComponentModal,
    modal
  },
  props: {
    name: String,
    interface: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object

  }
})
export default class PersonPage extends Vue {
  tab = 'xtab-0'
  avatarFile = null
  avatarImage = null
  avatarImageLabel = null

  signatureFile = null
  signatureImage = null
  get signatureImageLabel () {
    const signatureImage = this.elements[0].inputs.find(element => element.name === 'signatureImage')
    return signatureImage ? signatureImage.label : ''
  }

  nmInterface = null
  interfaceDetails = false
  editMode = false
  contactPersonForm = {}
  contactPersonData = []
  contactPersonShow = false
  addressPersonForm = {}
  addressPersonData = []
  addressPersonShow = false
  addressPersonType = {
    correspondence: 20030002
  }

  actualSavedEmails = null
  actualSavedPhones = null
  dadosModal = { show: false, label: '', interface: '' };

  exceptionArguments = ''

  async mounted () {
    this.nmInterface = this.elements[0].nmInterface.split('.')[1]
    this.avatarImageLabel = this.elements[0].inputs.find(element => element.name === 'photo').label
    this.signatureImageLabel = this.elements[0].inputs.find(element => element.name === 'signatureImage').label
    if (this.nmInterface === 'detalhar') {
      this.interfaceDetails = true
    }
    if (this.elements[0].dadosForm.photo && this.nmInterface !== 'gravar') {
      const file = await repository.downloadFile(
        this.elements[0].dadosForm.photo,
        null,
        'PERSON_IMAGE'
      )
      this.previewAvatarImage(file)
    }

    if (this.elements[0].dadosForm.signatureImage && this.nmInterface !== 'gravar') {
      const file = await repository.downloadFile(
        this.elements[0].dadosForm.signatureImage,
        null,
        'SIGNATURE_IMAGE'
      )
      this.previewSignatureImage(file)
    }
  }

  get inputs () {
    return this.elements[0].inputs.filter(
      (ci) => ci.type !== 'COMPOSICAO' && ci.type !== 'FILE'
    )
  }

  teste () {
    this.dadosModal = { show: false, label: '', interface: '' }
  }

  updated () {
    if (!this.elements[0].dadosForm.available && this.nmInterface == 'gravar') {
      this.resetAvatarImage()
    }
  }

  async avatarFileChange (file) {
    if (file) {
      if (file.name.length > 50) {
        messageBox.warn(this.$gettext('FILE_LONG_NAME'))
        this.resetAvatarImage()
      } else {
        this.previewAvatarImage(file)
        const name = await repository.updateFile('person.upload', 'photo', file)
        this.elements[0].dadosForm.photo = name
      }
    } else {
      this.resetAvatarImage()
    }
  }

  async signatureFileChange (file) {
    if (file) {
      if (file.name.length > 50) {
        messageBox.warn(this.$gettext('FILE_LONG_NAME'))
        this.resetSignatureImage()
      } else {
        this.previewSignatureImage(file)
        const name = await repository.updateFile('physicalPerson.signatureImageUpload', 'signatureImage', file)
        this.elements[0].dadosForm.signatureImage = name
      }
    } else {
      this.resetSignatureImage()
    }
  }

  previewAvatarImage (file) {
    const reader = new FileReader()
    reader.onload = () => {
      this.avatarImage = reader.result
    }
    reader.readAsDataURL(file)
  }

  previewSignatureImage (file) {
    const reader = new FileReader()
    reader.onload = () => {
      this.signatureImage = reader.result
    }
    reader.readAsDataURL(file)
  }

  resetAvatarImage () {
    this.avatarFile = null
    this.avatarImage = null
    this.elements[0].dadosForm.photo = null
  }

  resetSignatureImage () {
    this.signatureFile = null
    this.signatureImage = null
    this.elements[0].dadosForm.signatureImage = null
  }

  get urlAvatar () {
    return this.avatarImage || defaultAvatarImage
  }

  get urlSignature () {
    return this.signatureImage || defaultSignatureImage
  }

  formateInputsArray () {
    return _.chain(this.elements[0].inputs)
      .orderBy((input) => input.type === 'COMPOSICAO', ['asc'])
      .groupBy((input) =>
        input.type === 'COMPOSICAO' ? 'composition' : 'input'
      )
      .toPairs()
      .map((item) => _.zipObject(['type', 'elements'], item))
      .value()
  }

  newContactPerson (data) {
    this.editMode = false
    this.openContactPerson(data)
  }

  editContactPerson (data) {
    this.editMode = true
    this.openContactPerson(data)
  }

  onRemoveContactPersonHandler (index) {
    this.elements[0].dadosForm.contactPersons.splice(index, 1)
  }

  openContactPerson (data) {
    this.contactPersonShow = true
    this.contactPersonForm = JSON.parse(JSON.stringify(data))
    this.actualSavedEmails = null
    this.actualSavedPhones = null
    this.actualSavedPhones = data?.dadosForm?.contactPersonPhones?.map(cpe => cpe?.phone)
    this.actualSavedEmails = data?.dadosForm?.contactPersonEmails?.map(cpe => cpe?.email)
    this.contactPersonData = JSON.parse(JSON.stringify(this.elements[0].dadosForm.contactPersons))
    this.$nextTick(() => {
      this.$refs.contactPersonModal.show()
    })
  }

  onAddContactSuccessHandler (dados) {
    try {
      this.isEmailContactArrayAutoRepeated(dados.contactPersonEmails)
      this.hasEmailsAlreadySavedForClient(dados)
      this.isPhoneContactArrayAutoRepeated(dados.contactPersonPhones)
      this.hasPhoneAlreadySavedForClient(dados)
      this.elements[0].dadosForm.contactPersons.push(dados)
      this.$refs.contactPersonModal.hide()
      this.contactPersonShow = true
    } catch (error) {
      this.dealWithContactExceptions(error)
    }
  }

  dealWithContactExceptions (error) {
    switch (error) {
      case 'emailRepeatedException':
        messageBox.warn(this.$gettextInterpolate(this.$gettext('EMAIL_ALREADY_SAVED_TO_THIS_CLIENT'), { email: this.exceptionArguments }))
        this.exceptionArguments = ''
        break
      case 'sameValueOnEmailInputException':
        messageBox.warn(this.$gettextInterpolate(this.$gettext('NOT_ALLOWED_SAVE_REPEATED_EMAILS'), { email: this.exceptionArguments }))
        this.exceptionArguments = ''
        break
      case 'phoneRepeatedException' :
        messageBox.warn(this.$gettextInterpolate(this.$gettext('PHONE_ALREADY_SAVED_TO_THIS_CLIENT'), { phone: this.exceptionArguments }))
        this.exceptionArguments = ''
        break
      case 'samePhoneValueOnInputPhoneException' :
        messageBox.warn(this.$gettextInterpolate(this.$gettext('NOT_ALLOWED_SAVE_REPEATED_PHONES'), { phone: this.exceptionArguments }))
        this.exceptionArguments = ''
        break
      default:
        console.error('onAddContactSuccessHandler', error)
        break
    }
  }

  hasEmailsAlreadySavedForClient (data) {
    if (data.contactPersonEmails != null) {
      const emailList = this.elements[0].dadosForm.contactPersons.flatMap(cp => cp?.contactPersonEmails)?.map(cpe => cpe?.email).filter(cpe => cpe)
      const finalEmailList = emailList.concat(data.contactPersonEmails.map(cpe => cpe.email))
      const setFinalEmailList = new Set()
      const duplicatedValues = new Set()

      finalEmailList.forEach(email => {
        if (setFinalEmailList.has(email)) {
          duplicatedValues.add(email)
        } else {
          setFinalEmailList.add(email)
        }
      })

      if (duplicatedValues.size > 0) {
        this.exceptionArguments = Array.from(duplicatedValues).join(', ')
        throw 'emailRepeatedException'
      }
    }
  }

  hasPhoneAlreadySavedForClientChange (data) {
    if (data != null) {
      const phoneList = this.elements[0].dadosForm.contactPersons.flatMap(cp => cp.contactPersonPhones).map(cpe => cpe?.phone).filter(e => e)
      const finalPhoneList = phoneList.concat(data)
      const setFinalPhoneList = new Set()
      const duplicatedValues = new Set()

      finalPhoneList.forEach(phone => {
        if (setFinalPhoneList.has(phone)) {
          duplicatedValues.add(phone)
        } else {
          setFinalPhoneList.add(phone)
        }
      })

      if (duplicatedValues.size > 0) {
        this.exceptionArguments = Array.from(duplicatedValues).join(', ')
        throw 'phoneRepeatedException'
      }
    }
  }

  hasEmailsAlreadySavedForClientChange (data) {
    if (data != null) {
      const emailList = this.elements[0].dadosForm.contactPersons.flatMap(cp => cp.contactPersonEmails).map(cpe => cpe.email).filter(cpe => cpe)
      const finalEmailList = emailList.concat(data)
      const setFinalEmailList = new Set()
      const duplicatedValues = new Set()

      finalEmailList.forEach(email => {
        if (setFinalEmailList.has(email)) {
          duplicatedValues.add(email)
        } else {
          setFinalEmailList.add(email)
        }
      })
      if (duplicatedValues.size > 0) {
        this.exceptionArguments = Array.from(duplicatedValues).join(', ')
        throw 'emailRepeatedException'
      }
    }
  }

  hasPhoneAlreadySavedForClient (data) {
    if (data.contactPersonPhones != null) {
      const phoneList = this.elements[0].dadosForm.contactPersons.flatMap(cp => cp.contactPersonPhones).map(cpe => cpe?.phone).filter(e => e)
      const finalPhoneList = phoneList.concat(data.contactPersonPhones.map(cpp => cpp.phone))
      const setFinalPhoneList = new Set()
      const duplicatedValues = new Set()

      finalPhoneList.forEach(phone => {
        if (setFinalPhoneList.has(phone)) {
          duplicatedValues.add(phone)
        } else {
          setFinalPhoneList.add(phone)
        }
      })

      if (duplicatedValues.size > 0) {
        this.exceptionArguments = Array.from(duplicatedValues).join(', ')
        throw 'phoneRepeatedException'
      }
    }
  }

  isPhoneContactArrayAutoRepeated (array) {
    if (array != null) {
      if (array.length < 2) {
        return
      }
      const duplicatedValues = new Set()
      const setPhoneList = new Set()
      array.forEach(p => {
        if (setPhoneList.has(p.phone)) {
          duplicatedValues.add(p.phone)
        } else {
          setPhoneList.add(p.phone)
        }
      })
      if (duplicatedValues.size > 0) {
        this.exceptionArguments = Array.from(duplicatedValues).join(', ')
        throw 'samePhoneValueOnInputPhoneException'
      }
    }
  }

  isEmailContactArrayAutoRepeated (array) {
    if (array != null) {
      if (array.length < 2) {
        return
      }
      const duplicatedValues = new Set()
      const setEmailList = new Set()
      array.forEach(e => {
        if (setEmailList.has(e.email)) {
          duplicatedValues.add(e.email)
        } else {
          setEmailList.add(e.email)
        }
      })
      if (duplicatedValues.size > 0) {
        this.exceptionArguments = Array.from(duplicatedValues).join(', ')
        throw 'sameValueOnEmailInputException'
      }
    }
  }

  onEditContactSuccessHandler (dados) {
    try {
      let emailsJustSavedOnGrid = null
      let phonesJustSavedOnGrid = null

      if (dados.contactPersonPhones && this.actualSavedPhones) {
        phonesJustSavedOnGrid = Array.from(dados.contactPersonPhones.map(e => e.phone)).filter(phone => !this.actualSavedPhones.includes(phone))
          .concat(this.actualSavedPhones.filter(phone => !Array.from(dados.contactPersonPhones.map(e => e.phone)).includes(phone)))
      } else if (dados.contactPersonPhones && !phonesJustSavedOnGrid) {
        this.hasPhoneAlreadySavedForClient(dados)
      } else {
        dados.contactPersonPhones = null
      }

      if (dados.contactPersonEmails && this.actualSavedEmails) {
        emailsJustSavedOnGrid = Array.from(dados.contactPersonEmails.map(e => e.email)).filter(email => !this.actualSavedEmails.includes(email))
          .concat(this.actualSavedEmails.filter(email => !Array.from(dados.contactPersonEmails.map(e => e.email)).includes(email)))
      } else if (dados.contactPersonEmails && !emailsJustSavedOnGrid) {
        this.hasEmailsAlreadySavedForClient(dados)
      } else {
        dados.contactPersonEmails = null
      }
      this.isEmailContactArrayAutoRepeated(dados.contactPersonEmails)
      if (emailsJustSavedOnGrid) {
        const emailsToCompare = emailsJustSavedOnGrid.filter((element) => !this.actualSavedEmails.includes(element))
        this.hasEmailsAlreadySavedForClientChange(emailsToCompare)
      }
      this.isPhoneContactArrayAutoRepeated(dados.contactPersonPhones)
      if (phonesJustSavedOnGrid) {
        const phonesToCompare = phonesJustSavedOnGrid.filter((element) => !this.actualSavedPhones.includes(element))
        this.hasPhoneAlreadySavedForClientChange(phonesToCompare)
      }
      const index = dados.nrLinhaSelecionada
      Object.assign(this.elements[0].dadosForm.contactPersons[index], dados)
      this.$refs.contactPersonModal.hide()
      this.contactPersonShow = true
    } catch (error) {
      this.dealWithContactExceptions(error)
    }
  }

  newAddressPerson (data) {
    this.editMode = false
    this.openAddressPerson(data)
  }

  editAddressPerson (data) {
    this.editMode = true
    this.openAddressPerson(data)
  }

  onRemoveAddressHandler (index) {
    this.elements[0].dadosForm.addressPersons.splice(index, 1)
  }

  openAddressPerson (data) {
    this.addressPersonShow = true
    this.addressPersonForm = JSON.parse(JSON.stringify(data))
    this.addressPersonData = JSON.parse(JSON.stringify(this.elements[0].dadosForm.addressPersons))
    this.$nextTick(() => {
      this.$refs.addressPersonModal.show()
    })
  }

  onAddAddressSuccessHandler (dados) {
    try {
      this.isValidAdress(dados)
      this.elements[0].dadosForm.addressPersons.push(dados)
      this.$refs.addressPersonModal.hide()
      this.addressPersonShow = true
    } catch (error) {
      switch (error) {
        case 'repeatedAdressException':
          messageBox.warn(this.$gettextInterpolate(this.$gettext('ADRESS_TYPE_JUST_IN_USE'), { addressType: this.exceptionArguments }))
          this.exceptionArguments = ''
          break
        default:
          console.error('onEditAddressSuccessHandler', error)
          break
      }
    }
  }

  onEditAddressSuccessHandler (dados) {
    try {
      this.isValidAdress(dados)
      const index = dados.nrLinhaSelecionada
      Object.assign(this.elements[0].dadosForm.addressPersons[index], dados)
      this.$refs.addressPersonModal.hide()
      this.addressPersonShow = true
    } catch (error) {
      switch (error) {
        case 'repeatedAdressException':
          messageBox.warn(this.$gettextInterpolate(this.$gettext('ADRESS_TYPE_JUST_IN_USE'), { addressType: this.exceptionArguments }))
          this.exceptionArguments = ''
          break
        default:
          console.error('onEditAddressSuccessHandler', error)
          break
      }
    }
  }

  onRemoveDocumentHandler (index) {
    this.elements[0].dadosForm.documentPersons.splice(index, 1)
  }

  isValidAdress (addressForm) {
    const adressFormStreetAndNumberKey = addressForm.address_name + addressForm?.number
    this.elements[0].dadosForm.addressPersons.forEach((elementsOnGridComposition) => {
      const actualElementOnGridCompositionStreetAndNumberKey = elementsOnGridComposition.address_name + elementsOnGridComposition?.number
      this.hasPhysicalOrBillingAdressTypeAlreadySaved(addressForm, elementsOnGridComposition)
      this.hasStreetAndNumberAlreadySavedToThisAdrressType(addressForm, elementsOnGridComposition, adressFormStreetAndNumberKey, actualElementOnGridCompositionStreetAndNumberKey)
    })
  }

  hasStreetAndNumberAlreadySavedToThisAdrressType (addressForm, elementsOnGridComposition, adressFormStreetAndNumberKey, actualElementOnGridCompositionStreetAndNumberKey) {
    if (this.isEqualsAddresType(addressForm.addressPersonType, elementsOnGridComposition.addressPersonType)) {
      if (this.isEqualsStreetAndNumberAddress(adressFormStreetAndNumberKey, actualElementOnGridCompositionStreetAndNumberKey)) {
        if (typeof addressForm.nrLinhaSelecionada === 'undefined') {
          messageBox.warn(this.$gettext('STREET_AND_NUMBER_ALREADY_SAVED_TO_ADDRESS_TYPE'))
          throw 'repeatedAdressStreetAndException'
        }
        if (addressForm.nrLinhaSelecionada != elementsOnGridComposition.__index) {
          messageBox.warn(this.$gettext('STREET_AND_NUMBER_ALREADY_SAVED_TO_ADDRESS_TYPE'))
          throw 'repeatedAdressStreetAndException'
        }
      }
    }
  }

  hasPhysicalOrBillingAdressTypeAlreadySaved (addressForm, elementOnGridComposition) {
    if (this.isEqualsAddresType(addressForm.addressPersonType, elementOnGridComposition.addressPersonType)) {
      if (elementOnGridComposition.addressPersonType != this.addressPersonType.correspondence) {
        if (typeof addressForm.nrLinhaSelecionada === 'undefined') {
          this.exceptionArguments = addressForm.addressPersonType_nmDescricao
          throw 'repeatedAdressException'
        }
        if (addressForm.nrLinhaSelecionada != elementOnGridComposition.__index) {
          this.exceptionArguments = addressForm.addressPersonType_nmDescricao
          throw 'repeatedAdressException'
        }
      }
    }
  }

  isEqualsAddresType (newType, currentType) {
    if (newType == currentType) {
      return true
    }
    return false
  }

  isEqualsStreetAndNumberAddress (newAdrress, currentAddress) {
    if (newAdrress == currentAddress) {
      return true
    }
    return false
  }

  get compositions () {
    this.computedCompositionsTypeElements.forEach((composition) => {
      if (composition.model === 'contactPersons') {
        if (composition.data) {
          composition.data.forEach((row, index) => {
            if (row.contactPersonEmails?.length) {
              row.contactPersonEmailsMain = row.contactPersonEmails[0].email
              row.contactPersonEmailsSub = row.contactPersonEmails
                .slice(1, row.contactPersonEmails.length)
                .map((e) => e.email)
                .join(', ')
            }

            if (row.contactPersonPhones?.length) {
              row.contactPersonPhonesMain = row.contactPersonPhones[0].phone
              row.contactPersonPhonesSub = row.contactPersonPhones
                .slice(1, row.contactPersonPhones.length)
                .map((e) => e.phone)
                .join(', ')
            }
          })
        }
      }
    })
    const _self = this
    setTimeout(() => {
      _self.$forceUpdate()
    }, 350)
    return this.computedCompositionsTypeElements
  }

  get computedCompositionsTypeElements () {
    const compositions = this.formateInputsArray()
    return (
      _.chain(compositions)
        .find((ci) => ci.type === 'composition')
        .get('elements')
        .map((e) => {
          e.data = this.elements[0].dadosForm[e.model]
          e.uuid = 'id'
          e.columns.map((col) => {
            col.name = col.name || col.model
            col.field = col.name
            col.sortable = true
            col.align = 'left'
            return col
          })
          if (e.model === 'contactPersons' || e.model === 'addressPersons') {
            e.allowCustomEditModal = true
          }
          return e
        })
        .value() ?? []
    )
  }

  isValid () {
    return this.$refs.compositions.isValid()
  }

  limparForm () {
    this.resetAvatarImage()
    this.resetSignatureImage()
    Array.isArray(this.$refs.dynamicForm)
      ? this.$refs.dynamicForm[0].resetForm()
      : this.$refs.dynamicForm.resetForm()
    this.elements[0].dadosForm.addressPersons = []
    this.elements[0].dadosForm.contactPersons = []
    this.elements[0].dadosForm.documentPersons = []
  }

  hasProperty (property) {
    if (!this.elements) return false
    return !!this.elements[0]?.dadosForm?.[property]
  }

  async openModal (modalInterface, label) {
    this.dadosModal = {
      show: true,
      label,
      interface: modalInterface,
      person: this.elements[0].dadosForm.person
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';
.text-sub {
  font-size: 0.8rem;
}

.dynamic-compositions {
  .hidden-row > div {
    width: 100%;
    padding: 5px 12px;
  }

  .hidden-row > div:nth-child(odd) {
    background-color: $grey-3;
  }

  .q-table--no-wrap td {
    white-space: inherit !important;
  }
}

.q-td {
  white-space: none;
}

.container-page-person{
  height: calc(74vh - 0px);
}

.container-person {
  .dynamic-form #scroll-area {
    height: calc(34vh - 12px) !important;
  }

 .dynamic-compositions{
    .dynamic-form #scroll-area {
    height: calc(50vh - 12px)!important;
  }
 }
}

@media only screen and (max-height: 880px) {
  .container-person {
    .dynamic-form #scroll-area {
      height: calc(38vh - 12px) !important;
    }

  .addressPersonForms{
    .dynamic-form #scroll-area {
      height: calc(66vh - 12px) !important;
      }
    }
  }
}

@media only screen and (max-height: 800px) {
  .container-person {
    .dynamic-form #scroll-area {
      height: calc(40vh - 12px) !important;
    }
  }
}

@media only screen and (max-height: 760px) {
  .container-page-person{
    height: calc(70vh - 0px);
  }

  .container-person {
    .dynamic-form #scroll-area {
      height: calc(43vh - 12px) !important;
    }
  }
}

@media only screen and (max-height: 710px) {
  .container-person {
  .dynamic-form #scroll-area {
    height: calc(48vh - 12px) !important;
    }
  }
}

.assignments {
  width: 75%;
  display: flex;
  padding: 30px 0;
  gap: 10px;
}

.btn-atribuation {
  border-radius: 0;
  font-size: 11px !important;
}

.btn-atribuation .in{
  color: white;
  text-transform: none;
}

.btn-carrier {
  background-color: #00CED1 !important;
}

.btn-generator {
  background-color: #FA8072 !important;
}

.btn-client {
  background-color: #F3C76E !important;
}

.btn-user {
  background-color: #7B68EE !important;
}

.btn-serviceProvider {
  background-color: #00FF7F !important;
}

.margin-bottom {
  margin-bottom: -250px;
}

.margin-top-minus {
  margin-top: -50px;
}

</style>
